"use strict";
// #region slider
var slider = document.querySelector(".slider");
var images = [
    "https://snipboard.io/VpZ8aF.jpg",
    "https://snipboard.io/t0b962.jpg",
    "https://snipboard.io/BzlZSp.jpg"
];
var currentImageIndex = 0;
document.querySelector(".slider__arrow-button--left").addEventListener("click", function() {
    currentImageIndex = (currentImageIndex - 1 + images.length) % images.length;
    slider.style.backgroundImage = "url('".concat(images[currentImageIndex], "')");
});
document.querySelector(".slider__arrow-button--right").addEventListener("click", function() {
    currentImageIndex = (currentImageIndex + 1) % images.length;
    slider.style.backgroundImage = "url('".concat(images[currentImageIndex], "')");
});
// #endregion
// #region icon
var icons = document.querySelectorAll(".nav__icon");
var menu = document.querySelector(".menu");
var menuStyle = window.getComputedStyle(menu);
var navLogos = document.querySelectorAll(".nav__logo");
var navLinks = document.querySelectorAll(".nav__link");
var toggleMenu = function() {
    if (menuStyle.display === "none" || menu.style.display === "none") {
        menu.style.display = "block";
        document.body.classList.add("menu-open");
    } else if (menu.style.display === "block") {
        menu.style.display = "none";
        document.body.classList.remove("menu-open");
    }
};
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = icons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var icon = _step.value;
        icon.addEventListener("click", toggleMenu);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
try {
    for(var _iterator1 = navLogos[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
        var navLogo = _step1.value;
        navLogo.addEventListener("click", function() {
            menu.style.display = "none";
            document.body.classList.remove("menu-open");
        });
    }
} catch (err) {
    _didIteratorError1 = true;
    _iteratorError1 = err;
} finally{
    try {
        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
            _iterator1.return();
        }
    } finally{
        if (_didIteratorError1) {
            throw _iteratorError1;
        }
    }
}
var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
try {
    for(var _iterator2 = navLinks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
        var navLink = _step2.value;
        navLink.addEventListener("click", function() {
            menu.style.display = "none";
            document.body.classList.remove("menu-open");
        });
    }
} catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
} finally{
    try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
        }
    } finally{
        if (_didIteratorError2) {
            throw _iteratorError2;
        }
    }
}
// #endregion
// #region content in header nav
function updateContent() {
    var navLinksHeader = document.querySelectorAll(".nav__link--header");
    for(var i = 0; i < navLinksHeader.length; i++)switch(i){
        case 0:
            break;
        case 1:
            navLinksHeader[i].textContent = "Services";
            navLinksHeader[i].setAttribute("href", "#services");
            break;
        case 2:
            navLinksHeader[i].textContent = "Testimonials";
            navLinksHeader[i].setAttribute("href", "#testimonials");
            break;
        case 3:
            navLinksHeader[i].textContent = "Contact Us";
            navLinksHeader[i].setAttribute("href", "#feedback");
            break;
        default:
            navLinksHeader[i].remove();
    }
}
updateContent();
window.addEventListener("resize", updateContent);
// #endregion
// #region sections appearance effect
var sections = document.querySelectorAll(".hidden");
var initialScroll = true;
var toggleSectionVisibility = function() {
    sections.forEach(function(section) {
        var sectionTop = section.getBoundingClientRect().top;
        var sectionBottom = section.getBoundingClientRect().bottom;
        var windowHeight = window.innerHeight;
        if (sectionTop < windowHeight - 20 && sectionBottom > 20) section.classList.add("visible");
        else if (!section.classList.contains("nav--header")) section.classList.remove("visible");
    });
};
var handleScroll = function() {
    if (initialScroll) {
        window.scrollTo(0, 0);
        initialScroll = false;
    }
    if (menu.style.display !== "block") toggleSectionVisibility();
};
window.addEventListener("scroll", handleScroll);
document.addEventListener("DOMContentLoaded", handleScroll); // #endregion

//# sourceMappingURL=index.89c8063a.js.map
